module Shared.Dto.Page.UserList

open System
open Shared
open Shared.Dto.Dto
open Shared.Dto.User

type BaseUserDataDto = {
    Mail: string
    FirstName: string
    LastName: string
    Password: string option
    LastActivity: DateTimeOffset option
}

type RegularUserDataDto = {
    Base: BaseUserDataDto
    Packages: IdValue<PurchasedPackage> list
    CustomerNumber: string option
    IsBlocked: bool
}

type TestUserDataDto = {
    Base: BaseUserDataDto
    ValidUntil: DateTime
}

type FullUserDto =
    | Admin of BaseUserDataDto
    | RegularUser of RegularUserDataDto
    | TestUser of TestUserDataDto

type UpdateUserIsBlockedRequest = {
    UserId: int
    IsBlocked: bool
}

type UserIsBlockedResult = {
    UserId: int
    UserName: string
    IsBlocked: bool
    Response: AuthenticatedResponse<bool>
}

type UserDeletedResult = {
    UserId: int
    UserName: string
    Response: AuthenticatedResponse<bool>
}

let getUserData user =
    match user with
    | Admin data -> data
    | RegularUser data -> data.Base
    | TestUser data -> data.Base

let getFirstName user = (getUserData user).FirstName

let getLastName user = (getUserData user).LastName

let getMail user = (getUserData user).Mail

let getLastActivity user = (getUserData user).LastActivity

let getCustomerNumber user =
    match user with
    | RegularUser user -> user.CustomerNumber
    | _ -> None

let getPackages user =
    match user with
    | Admin _
    | TestUser _ -> []
    | RegularUser user -> user.Packages


let userTypeToString user =
    match user with
    | Admin _ -> "Administrator"
    | RegularUser _ -> "Benutzer"
    | TestUser _ -> "Test-Benutzer"

let getFullName user =
    sprintf "%s %s" (getLastName user) (getFirstName user)

let updateIsBlockedStatus (isBlocked: bool) (user: FullUserDto) : FullUserDto =
    match user with
    | RegularUser user -> RegularUser { user with IsBlocked = isBlocked }
    | _ -> user